module.exports = __webpack_public_path__ + "static/24-df82ce47e98d776f0def663f933ac37d.jpg";